(function() {
    'use strict';
    
a3_cabin_reports.service("UpdateService", UpdateService);

    /**
    * @memberof CabinReports
    * @ngdoc service
    * @name UpdateService
    * @description 
    *  Update functionality
    * @ngInject
    */
function UpdateService(SyncLogFactory) {
        /**
         * Version patcher
         * @memberof UpdateService
         * @returns {string} NeedsSync 
         */
		function patcher(version) {
			var NeedsSync = false;
			if (version == "1.0") {
				SyncLogFactory.updateSyncVersion("1.1")
					//patching to next version
				patcher("1.1");
				NeedsSync = true;
			} else if (version == "1.1") {
				SyncLogFactory.updateSyncVersion("1.2")
					//patching to next version
					//patcher("1.2");
				NeedsSync = true;
			}

			return NeedsSync;

		}
		return {
            /**
             * updates application 
             * @memberof UpdateService
             * @returns {string} NeedsSync 
             */
			updater: function() {
				var synclog = SyncLogFactory.getSyncLog();
				if (synclog == undefined || synclog == null) {
					return false;
				} else if (synclog.isUpdated) {
					return true;
				} else {
					var NeedsSync = patcher(synclog.version);
					return NeedsSync;
				}
			}
		};
	}
    
})();
